<template>
  <label :class="{ 'not-bold': !isBold }">{{ formattedContent }}</label>
</template>

<script>
export default {
  name: 'Label',
  props: {
    content: {
      type: String,
      required: true,
    },
    isBold: {
      type: Boolean,
      required: false,
      default: true,
    },
    percentage: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    formattedContent() {
      if (this.content === null || this.content === undefined) {
        return '';
      }
      return this.percentage ? `%${this.content}` : this.content;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

label {
  color: $colorN80;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.05px;

  &.not-bold {
    font-weight: 400;
  }
}
</style>
